import axios from "axios";

const host = process.env.VUE_APP_SINGTEL_INTEGRATION_URL

export default class SingtelSubscriptionService {
  static async checkSubscription(msisdn) {
    const response = await axios.post(`${host}/get-user-subscription`, {
      msisdn,
    });

    return response.data;
  }

  static async subscribe(msisdn, tracking = {}) {
    const response = await axios.post(`${host}/auth/subscribe`, {
      msisdn,
      ...tracking,
    });

    return response.data;
  }

  static async validateOTP(sessionId, pin) {
    const response = await axios.post(`${host}/auth/validate-pin`, {
      sessionId,
      pin,
    });

    return response.data;
  }

  static async unsubscribe(msisdn) {
    const response = await axios.post(`${host}/auth/unsubscribe`, {
      msisdn,
    });

    return response.data;
  }
}
